/**
 * Privilege names available on the platform
 */
export const PRIVILEGES = {
  POST_ARTICLE: 'Post Article',
  BLOCK_OTHERS_TO_POST: 'Block others to post',
  CHAT: 'Chat',
  CREATE_ARTICLE: 'Create article',
  COMMENT: 'Comment',
  LIKE: 'Like',
  FLAG_CONTENT: 'Flagcontent',
  REVIEW_CONTENT: 'Review content',
  CREATE_GROUP: 'Create gruop', // Note: typo in backend
  POST_CONTENT: 'Post Content'
};

/**
 * Check if user has a specific privilege
 * @param {string} privilegeName - Name of the privilege to check
 * @returns {boolean} - True if user has the privilege and it's active
 */
export const hasPrivilege = (privilegeName) => {
  try {
    const privileges = JSON.parse(sessionStorage.getItem("privileges") || "[]");
    return privileges.some(
      priv => priv.socialPrivilege?.name === privilegeName && priv.status === 1
    );
  } catch (error) {
    console.error('Error checking privilege:', error);
    return false;
  }
};

/**
 * Check multiple privileges at once
 * @param {string[]} privilegeNames - Array of privilege names to check
 * @returns {boolean} - True if user has ALL the specified privileges
 */
export const hasAllPrivileges = (privilegeNames) => {
  return privilegeNames.every(name => hasPrivilege(name));
};

/**
 * Check if user has at least one of the specified privileges
 * @param {string[]} privilegeNames - Array of privilege names to check
 * @returns {boolean} - True if user has ANY of the specified privileges
 */
export const hasAnyPrivilege = (privilegeNames) => {
  return privilegeNames.some(name => hasPrivilege(name));
};

/**
 * Get all user privileges
 * @returns {Array} - Array of user privilege objects
 */
export const getUserPrivileges = () => {
  try {
    return JSON.parse(sessionStorage.getItem("privileges") || "[]");
  } catch (error) {
    console.error('Error getting user privileges:', error);
    return [];
  }
};

/**
 * Check if user can perform article actions
 * @returns {boolean}
 */
export const canManageArticles = () => {
  return hasPrivilege(PRIVILEGES.CREATE_ARTICLE) || hasPrivilege(PRIVILEGES.POST_ARTICLE);
};

/**
 * Check if user can interact socially (like, comment)
 * @returns {boolean}
 */
export const canInteractSocially = () => {
  return hasAnyPrivilege([PRIVILEGES.LIKE, PRIVILEGES.COMMENT]);
};

/**
 * Check if user can moderate content
 * @returns {boolean}
 */
export const canModerateContent = () => {
  return hasAnyPrivilege([
    PRIVILEGES.REVIEW_CONTENT,
    PRIVILEGES.FLAG_CONTENT,
    PRIVILEGES.BLOCK_OTHERS_TO_POST
  ]);
};
